import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

// eslint-disable-next-line import/no-anonymous-default-export
export default props => (
  <SvgIcon {...props} viewBox="0 0 23.109 23.124">
    <g id="Action" transform="translate(-92.011 -101.74)" fillRule="nonzero">
      <path
        id="path1010"
        d="m101.01 101.74v2.3203a9.525 9.525 0 0 0-2.0743 0.85473l-1.6459-1.6536-1.9498 1.9523 0.0052 5e-3 -1.7436 1.741 1.635 1.6356a9.398 9.398 0 0 0-0.86765 2.0846h-2.3549v5.2307h2.344a9.525 9.525 0 0 0 0.85731 2.0665l-1.6511 1.6536 3.7042 3.7042 1.6567-1.6562a9.4245 9.4245 0 0 0 2.0846 0.84904v2.3363h5.2178v-2.3518a9.4562 9.4562 0 0 0 2.0557-0.8599l1.6485 1.6485 1.8226-1.8231-5e-3 -5e-3 1.8707-1.8707-1.6588-1.6588a9.5806 9.5806 0 0 0 0.83871-2.0324h2.3228v-5.2306h-2.3125a9.525 9.525 0 0 0-0.84905-2.0608l1.6428-1.6407-3.7042-3.7042-1.6376 1.6382a9.4932 9.4932 0 0 0-2.0397-0.85215v-2.3203z"
        fill="#4db0e1"
      />
      <path
        id="path8-6-0"
        d="m92.093 110.66v5.2308h2.3125a9.525 9.525 0 0 0 0.84931 2.0611l-1.6431 1.6404 3.7042 3.7042 1.6378-1.6378a9.4932 9.4932 0 0 0 2.0399 0.85196v2.3204h5.2123v-2.3204a9.525 9.525 0 0 0 2.0743-0.8546l1.6457 1.6536 1.95-1.9526-16.404-16.264-1.8759 1.8759 1.6589 1.6589a9.5806 9.5806 0 0 0-0.83873 2.032z"
        fill="#4db0e1"
      />
      <path
        id="path10-3-0"
        d="m93.599 106.96 1.6351 1.6351a9.398 9.398 0 0 0-0.86783 2.0849h-2.3548v5.2308h2.3442a9.525 9.525 0 0 0 0.85725 2.0664l-1.651 1.6536 3.7042 3.7042 1.6563-1.6563a9.4245 9.4245 0 0 0 2.0849 0.84931v2.3363h5.2176v-2.3521a9.4562 9.4562 0 0 0 2.0558-0.8599l1.6484 1.6484 1.823-1.823-16.404-16.264z"
        fill="#283782"
        fillOpacity=".2"
      />
      <path
        id="path871-7"
        d="m106.69 107.2h-3.4025l3.7809 5.9346-3.7809 5.9346h3.4025l3.7809-5.9346z"
        fill="#283983"
      />
      <path
        id="path873-9"
        d="m101.39 107.2h-3.4025l3.7809 5.9346-3.7809 5.9346h3.4025l3.7835-5.9346z"
        fill="#283983"
      />
    </g>
  </SvgIcon>
);
